/**
 * Validates the date range
 */
export const validateDateRange = (fromDate, toDate) => {
  if (!fromDate || !toDate) {
    return {
      valid: false,
      message: "You must select both dates"
    };
  }

  if (new Date(fromDate) > new Date(toDate)) {
    return {
      valid: false,
      message: "The start date cannot be later than the end date"
    };
  }

  return { valid: true };
};